import { buildMeetingsBucketDemoRow, emptyMeetingLoadBucket, generateMeetingsBucketMockRaw, sharePercent } from '@web/lib/demo/utils/meetingsBucketDemoUtils';
import { emptyMeetingsByWhoAttendedRawCounts, MEETINGS_BY_WHO_ATTENDED_KEYS } from '@workalizer/shared';
export var meetingsByWhoAttendedAnalytic = function (input) {
    var includeTeamMetrics = input.userId == null;
    var current = emptyMeetingsByWhoAttendedRawCounts();
    var previous = emptyMeetingsByWhoAttendedRawCounts();
    for (var _i = 0, MEETINGS_BY_WHO_ATTENDED_KEYS_1 = MEETINGS_BY_WHO_ATTENDED_KEYS; _i < MEETINGS_BY_WHO_ATTENDED_KEYS_1.length; _i++) {
        var key = MEETINGS_BY_WHO_ATTENDED_KEYS_1[_i];
        current[key] = generateMeetingsBucketMockRaw();
        previous[key] = generateMeetingsBucketMockRaw();
    }
    // External-heavy is a subset of with-external for demo realism.
    current.externalHeavy.meetingCount = Math.min(current.externalHeavy.meetingCount, current.withExternal.meetingCount);
    previous.externalHeavy.meetingCount = Math.min(previous.externalHeavy.meetingCount, previous.withExternal.meetingCount);
    var currentTotal = current.teamInternal.meetingCount +
        current.crossTeam.meetingCount +
        current.withExternal.meetingCount;
    var previousTotal = previous.teamInternal.meetingCount +
        previous.crossTeam.meetingCount +
        previous.withExternal.meetingCount;
    return {
        rows: MEETINGS_BY_WHO_ATTENDED_KEYS.map(function (key) {
            var _a, _b;
            var curr = (_a = current[key]) !== null && _a !== void 0 ? _a : emptyMeetingLoadBucket();
            var prev = (_b = previous[key]) !== null && _b !== void 0 ? _b : emptyMeetingLoadBucket();
            return buildMeetingsBucketDemoRow(key, curr, prev, sharePercent(curr.meetingCount, currentTotal), sharePercent(prev.meetingCount, previousTotal), includeTeamMetrics);
        })
    };
};
